

export const ROLES = Object.freeze({
	FREE: 'free',
	PREMIUM: 'premium',
	PROFESSIONAL: 'professional',
	ADMIN: 'admin'
});